import {Grid, Toolbar, Typography, Paper} from '@material-ui/core';
import IconButton from '@material-ui/core/IconButton';
import Tooltip from '@material-ui/core/Tooltip';
import PublishRoundedIcon from '@material-ui/icons/PublishRounded';
import {
  changeEnrollmentApplicationFilters,
  clearEnrollmentFileApplications,
  clearSort,
  enrollmentApplicationsFiltersEmpty,
  getEnrollmentApplications,
} from 'Enrollment/ducks/enrollmentFileProcessing';
import React, {useEffect} from 'react';
import {useDispatch, useSelector} from 'react-redux';
import {ReducerState} from 'rootReducer';
import UploadedEnrollmentApplicationsTable from './UploadedEnrollmentApplicationsTable';
import './UploadEnrollmentApplications.sass';
import {ModalState, showModal} from 'Core/ducks/modal';
import {selectUserScopes} from 'Users/selectors/userProfileSelectors';
import {Scope} from 'Shared/constants/Scope';
import * as O from 'fp-ts/lib/Option';

export const hasAbilityToUploadEnrollmentApplications = (scopes: Scope[]) =>
  scopes.some(scope => /et\.uploadenrollmentapplicationsfile\|(\*|2)/.test(scope));

const UploadEnrollmentApplications = () => {
  const {enrollmentApplications, enrollmentApplicationsFilters, sort} = useSelector(
    (state: ReducerState) => state.enrollmentFileProcessing
  );
  const dispatch = useDispatch();
  useEffect(() => {
    dispatch(getEnrollmentApplications(undefined, enrollmentApplicationsFilters, O.toUndefined(sort)));
  }, [dispatch, enrollmentApplicationsFilters, sort]);

  useEffect(() => {
    return () => {
      dispatch(clearEnrollmentFileApplications());
      dispatch(changeEnrollmentApplicationFilters(enrollmentApplicationsFiltersEmpty));
      dispatch(clearSort());
    };
  }, []);

  const scopes = useSelector(selectUserScopes);

  return (
    <div className="upload-enrollment-files">
      <Toolbar className="upload-enrollment-files-table">
        <Typography id="upload-enrollment-files-title" className="upload-enrollment-files-table__title" variant="h6">
          Uploaded Files
        </Typography>
        {hasAbilityToUploadEnrollmentApplications(scopes) && (
          <Tooltip title="Upload File">
            <IconButton
              id="upload-enrollment-files-upload-file-button"
              className="btn-upload"
              onClick={() => dispatch(showModal(ModalState.EnrollmentApplicationUpload()))}
              aria-label="Upload File"
            >
              <PublishRoundedIcon />
            </IconButton>
          </Tooltip>
        )}
      </Toolbar>
      {enrollmentApplications !== null ? (
        <UploadedEnrollmentApplicationsTable enrollmentFileMetaData={enrollmentApplications} />
      ) : (
        <Paper className="enrollment-file-dropzone">
          <Grid
            className="dropzone__enrollment__grid"
            container
            spacing={4}
            direction="column"
            alignItems="center"
            justify="center"
          >
            <Grid item xs={12} lg={5} md={6}>
              <div className="enrollment-file-dropzone__file-input">
                <div className="enrollment-file-dropzone__image" />

                <h3 className="enrollment-file-dropzone__title">No Uploaded Files</h3>

                <Typography className="enrollment-file-dropzone__content" variant="body2" color="initial">
                  No uploaded enrollment files. Click the "Upload File" button above to upload a new file.
                </Typography>
              </div>
            </Grid>
          </Grid>
        </Paper>
      )}{' '}
    </div>
  );
};

export default UploadEnrollmentApplications;
